import styled from "styled-components";

export const CardContainer = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  box-shadow: 0px 0.633px 3.163px 0px rgba(63, 65, 66, 0.2);
  background-color: ${({ theme }) => theme.bg.cardmodules};
  border-radius: ${({ borderRadius }) => `${borderRadius}px`};
  box-sizing: border-box;
  height: 100%;
`;

export const CardStep = styled.div`
  width: ${({ isFiveColumn }) => (isFiveColumn ? "32px" : "48px")};
  height: ${({ isFiveColumn }) => (isFiveColumn ? "32px" : "48px")};
  display: grid;
  place-content: center;
  border-radius: ${({ isFiveColumn }) => (isFiveColumn ? "9.33px" : "14px")};
  background-color: ${({ backgroundColor }) => backgroundColor};

  color: ${({ color }) => color};
  font-size: ${({ isFiveColumn }) => (isFiveColumn ? "14.222px" : "21.333px")};
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
`;

export const CardContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

export const CardHeading = styled.h1`
  all: unset;
  color: ${({ theme }) => theme.text.input};
  font-size: ${({ isFiveColumn }) => (isFiveColumn ? "16px" : "22px")};
  font-style: normal;
  font-weight: 600;
  line-height: 25.887px;
`;

export const CardParagraph = styled.p`
  all: unset;
  color: #868686;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
`;

export const CallToActionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const CardLabel = styled.span`
  color: ${({ color }) => color};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ArrowContainer = styled.div`
  display: grid;
  place-content: center;
  padding: 5px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
`;
